import API_BASE_URL from "../../utils/apiBase";
import React, { useEffect, useState } from "react";
import "./customer_revisit-form.css";
import WebcamCapture from '../webCam/WebCamCapture.jsx'; 
import { MdHistory, MdSearch } from "react-icons/md";
import ProjectLogo from "../ProjectLogo/ProjectLogo";
import { toast } from "react-toastify";

import { useLocation, useNavigate } from "react-router-dom";


const   CustomerRevisit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [customerNames, setCustomerNames] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [uploadedUrl, setUploadedUrl] = useState(null);
  const [error, setError] = useState("");
  const [isListOpen, setIsListOpen] = useState(false);
  const [loading, setLoading] = useState(false); // Spinner control
  const [errors,setErrors]=useState({
    imageUpload:""
  })

  // Handle input change
  const handleInputChange = (event) => {
    const value = event.target.value;
    setPhoneNumber(value);
    setSelectedCustomer(null);
    setIsListOpen(value.length >= 5);
    if (value.length >= 5) {
      handleSearchCustomer(value);
    } else {
      setCustomerNames([]);
    }
  };

  // Search customers
  const handleSearchCustomer = (phoneNumber) => {
    if (!phoneNumber) {
      setError("Please enter a phone number.");
      setCustomerNames([]);
      return;
    }

    setLoading(true);
    fetch(`${API_BASE_URL}/api/v1/customer/getRevisitSearch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ phoneNumber }),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(data)
        setLoading(false);
        if (data.error) {
          setError(data.error);
          setCustomerNames([]);
        } else {
          setError("");
          setCustomerNames(data.allSortedCustomers || []);
        }
      })
      .catch((error) => {
        setLoading(false);
        setError("Error searching for customers.");
        setCustomerNames([]);
        console.error("Error searching for customers:", error);
      });
  };

  // Handle customer selection
  function formatDateToDDMMYYYY(dateString) {
    const date = new Date(dateString); // Convert to Date object
    const day = String(date.getDate()).padStart(2, '0'); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-based, so +1) with leading zero
    const year = date.getFullYear(); // Get year
    return `${day}-${month}-${year}`; // Format as dd-mm-yyyy
  }
  const handleCustomerSelect = (customer) => {
    // console.log(customer)
    setSelectedCustomer({
      name: customer.name,
      phoneNumber: customer.phoneNumber,
      placeOfVisit: customer.placeOfVisit,
      firstVisit:formatDateToDDMMYYYY(customer.createdAt)

    });
    setIsListOpen(false);
    setError("");
  };
 useEffect(() => {
  if (uploadedUrl) {
    setErrors((prev) => ({
      ...prev,
      imageUpload: ""  // clear only imageUpload error
    }));
  }
}, [uploadedUrl]);

  // Update customer visit
  const handleUpdateCustomer = async (e) => {
    e.preventDefault();

    if (!selectedCustomer) {
      setError("No customer selected.");
      return;
    }
     if(uploadedUrl ==null){
           setErrors((prevErrors) => ({
      ...prevErrors,
      ["imageUpload"]: "please upload image to submit the form",

    }));
    return 
      }

    setLoading(true);
    try {
     
      const response = await fetch(`${API_BASE_URL}/api/v1/customer/revisit`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({...selectedCustomer,imageUrl:uploadedUrl}),
      });

      const responseData = await response.json();
      setLoading(false);

      if (response.ok) {
        toast.success(responseData.message);
        setTimeout(() => navigate("/form-selection"), 2000);
        setSelectedCustomer(null);
        setPhoneNumber("");
      } else {
        toast.error(responseData.message);
        setError(responseData.message);
      }
    } catch (error) {
      setLoading(false);
      toast.error(`Error updating customer: ${error.message}`);
      setError("Error updating customer.");
    }
  };

  return (
    <div className="customer-revisit-form">
      <div className="revisit-head">
        <span className="revisit-head-icon" aria-hidden="true">
          <MdHistory />
        </span>
        <div>
          <h2>Log a revisit</h2>
          <p>Find the visitor, take a photo, then update their visit.</p>
        </div>
      </div>

      <div className="revisit-step">
        <span className="reg-step" aria-hidden="true">1</span>
        <strong>Find the visitor</strong>
      </div>
      <div className="customer-revisit-checker">
        <div className="customer-input-check">
          <label htmlFor="phoneNumber" className="sr-only">
            Phone number or last five digits
          </label>
          <div className="revisit-search">
            <MdSearch className="revisit-search-icon" aria-hidden="true" />
            <input
              type="text"
              name="phoneNumber"
              id="phoneNumber"
              inputMode="numeric"
              autoComplete="off"
              placeholder="Phone number or last 5 digits"
              value={phoneNumber}
              onChange={handleInputChange}
            />
            {loading && !selectedCustomer && <span className="revisit-busy" aria-hidden="true" />}
          </div>
          {isListOpen && customerNames.length > 0 && phoneNumber ? (
            <div className="selection-check">
              <ul>
                {customerNames.map((customer, index) => (
                  <li key={index} onClick={() => handleCustomerSelect(customer)}>
                    <span className="revisit-result-name">{customer.name}</span>
                    <span className="revisit-result-project">
                      <ProjectLogo name={customer.placeOfVisit || "?"} size={20} />
                      {customer.placeOfVisit}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>

      <div className="revisit-step">
        <span className="reg-step" aria-hidden="true">2</span>
        <strong>Confirm and take a photo</strong>
      </div>
      <div className="customer-revisit-update">
        <div className="customer-input-update">
          {selectedCustomer ? (
            <div className="revisit-card">
              <ProjectLogo name={selectedCustomer.name} size={46} className="is-round" />
              <div className="revisit-card-main">
                <strong>{selectedCustomer.name}</strong>
                <span>{selectedCustomer.phoneNumber}</span>
              </div>
              <dl className="revisit-card-meta">
                <div>
                  <dt>Project</dt>
                  <dd>{selectedCustomer.placeOfVisit || "—"}</dd>
                </div>
                <div>
                  <dt>First visit</dt>
                  <dd>{selectedCustomer.firstVisit}</dd>
                </div>
              </dl>
            </div>
          ) : (
            <div className="revisit-card revisit-card--empty">
              Search above and pick the visitor to continue.
            </div>
          )}
          {selectedCustomer && (
            <WebcamCapture onUpload={(url) => setUploadedUrl(url)} onDelete={() => setUploadedUrl(null)} />
          )}
          {errors.imageUpload && <span className="error">{errors.imageUpload}</span>}
          <button onClick={handleUpdateCustomer} disabled={loading}>
            {loading && selectedCustomer ? "Updating..." : "Update Visit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerRevisit;
